import React, { useState } from "react";
import PdfResults from "../Dashboard/Search/PdfResults";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import SendFileDialog from "../Global/SendFileDialog";
import { useQuerySendFileOnEmail } from "../../hooks/react-query/useData";
import { Download, MailOutline } from "@mui/icons-material";

const PdfDisplayFlow = ({
  downloadPdf,
  pdfFileUrl,
  pdfBottomBtnStyles,
  docId,
}) => {
  const [open, setOpen] = useState("");
  const [userEmail, setUserEmail] = useState("");

  let { refetch: sendFileOnEmail } = useQuerySendFileOnEmail({
    email: userEmail,
    doc_id: docId,
  });

  const handeClose = () => {
    setOpen(false);
  };
  return (
    <Box>
      <SendFileDialog
        open={open}
        setOpen={setOpen}
        sendFileOnEmail={sendFileOnEmail}
        userEmail={userEmail}
        setUserEmail={setUserEmail}
        handeClose={handeClose}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          marginTop: "5%",
        }}
      >
        <PdfResults pdfSource={pdfFileUrl} />
      </Box>
      <Box
        sx={{
          ...pdfBottomBtnStyles,
        }}
      >
        <Button
          variant="downloadNow"
          sx={{ display: "flex", columnGap: "5px", backgroundColor: "#ff5722" }}
          onClick={() => downloadPdf(pdfFileUrl)}
        >
          DESCARGAR AHORA
          <Box
            sx={{
              width: "25px",
              height: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Download sx={{ color: "#fff", fontSize: "20px" }} />
          </Box>
        </Button>
        
        <Button
          variant="shareMail"
          sx={{
            display: "flex",
            columnGap: "5px",
            background: "#800080 !important",
          }}
          onClick={() => setOpen(true)}
        >
          COMPARTIR CORREO
          <Box
            sx={{
              width: "25px",
              height: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <MailOutline sx={{ color: "#fff", fontSize: "20px" }} />
          </Box>
        </Button>
      </Box>
    </Box>
  );
};

export default PdfDisplayFlow;
